<div class="mat-dialog-output-details">
    <div mat-dialog-title class="dialog-title">
        <h2>{{headerName}} </h2>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content class="mat-typography">
        <div class="rtsp-strea-view">
            <div class="no_record_found_msg" *ngIf="loading">
                Loading...
            </div>

            <mat-card class="lrtsp-view-card" *ngIf="errorMessage === '' && !loading ">
                <div class="borderBox">
                    <mat-card-content>
                        <div class="row">
                            <div>
                                <label>FPS:</label>
                                <span>{{ rtspData?.fps }}</span>
                            </div>
                            <div>
                                <label>Frame width:</label>
                                <span>{{ rtspData?.frame_width }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div>
                                <label>Frame Height:</label>
                                <span>{{ rtspData?.frame_height }}</span>
                            </div>
                            <div>
                                <label>FourCC:</label>
                                <span>{{ rtspData?.fourcc }}</span>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-content>
                        <div class="rtsp-thumbnail">
                            <img [src]="thumbnailImage" style="width: auto;height: 300px;"/>
                        </div>
                    </mat-card-content>
                </div>
            </mat-card>
            <div class="error-message" *ngIf="errorMessage !== '' ">
                <h4>{{errorMessage}}</h4>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-stroked-button [mat-dialog-close]="true">Close</button>
    </mat-dialog-actions>
</div>